import React, { useState } from "react";
import Contacts from "@/pages/contacts";
const Canadaworkingvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/cannads.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        
        </div>
      </div>
      <div className="mt-10 w-full text-center text-3xl font-bold text-[#011473] drop-shadow-md sm:w-3/4 md:ml-28">
        Canada Work Permit: Opportunities During and After Studies
      </div>
      <div className="mt-5 w-full text-left text-md font-bold text-gray-700 drop-shadow-md sm:w-3/4 md:ml-32">
        Currently, international students in Canada holding a valid student
        visa, along with their dependent family members (excluding dependants of
        master's by research or doctoral students who are permitted to work
        full-time), are allowed to work up to 20 hours per week during the
        academic term, once their course has started. During breaks or when
        classes are not in session, students can work unlimited hours. Under
        proposed regulations, the work limit would be adjusted to 40 hours every
        two weeks during the academic term, with a "fortnight" referring to a
        14-day period beginning on a Monday.
      </div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}
        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/working.jpg" // Replace with the correct path to your image
            alt="Steps to Apply for a Student Visa and Work Permit in Canada"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <div className="text-bold mb-2 text-black text-lg">
                Steps to Apply for a Student Visa and Work Permit in Canada:
              </div>
             <a className="text-black font-bold"> Submit Your Application: </a>Complete and submit your student visa
              application online or at the Canadian visa office.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Pay the Application Fee:</a> Pay the required application fee for both
              your student visa and work permit.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Provide Valid Passport:</a> Ensure your passport is valid for the
              duration of your intended stay in Canada.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Proof of Financial Support:</a> Demonstrate your financial capacity to
              cover tuition fees, living expenses and other associated costs
              during your studies.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Provide Academic and English Proficiency Information:</a> Submit your
              academic documents and proof of English proficiency (e.g., IELTS,
              TOEFL).
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Submit an Electronic Confirmation of Enrolment (eCoE):</a> Include
              your eCoE, confirming your enrolment in a recognized educational
              institution in Canada.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Health and Character Requirements:</a> Provide evidence of good health
              through a medical exam and a clean criminal record through a
              police clearance certificate.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Visa Compliance: </a>Ensure compliance with all visa conditions,
              including maintaining satisfactory academic progress and
              attendance.
            </span>
          </div>
        </div>
      </div>
      <div className="container mb-20 flex flex-col items-center justify-between lg:flex-row">
        <div className="flex-1">
          {/* Spouses & Dependents Section */}
          <div className="mt-5 flex items-center text-left">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h1 className="ml-4 mt-4 text-md font-bold text-[#011473] drop-shadow-md">
              Spouses & Dependents
            </h1>
          </div>
          <ul className="ml-6 w-full list-disc pl-5 text-left text-sm font-medium text-gray-700 sm:w-3/4">
            <li>
              Spouses and children under 18 can join you in Canada on a
              Dependent Visa.
            </li>
            <li>Spouses may also apply for a work permit.</li>
          </ul>

          {/* Canada Work Visa Section */}
          <div className="mt-5 flex items-center text-left">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h1 className="ml-4 mt-4 text-md font-bold text-[#011473] drop-shadow-md">
              Canada Work Visa: A Gateway to Career Opportunities
            </h1>
          </div>
          <ul className="ml-6 w-full list-disc pl-5 text-left text-sm font-medium text-gray-700 sm:w-3/4">
            <li>
              Canada offers work permits for skilled workers to fill labor
              shortages.
            </li>
            <li>
              Different work permit categories are available, such as Business
              Owner and Investor visas.
            </li>
          </ul>

          {/* Why Choose Visa World Section */}
          <div className="mt-5 flex items-center text-left">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h1 className="ml-4 mt-4 text-md font-bold text-[#011473] drop-shadow-md">
              Why Choose Visa World for Your Immigration Journey
            </h1>
          </div>
          <ul className="mb-5 ml-6 w-full list-disc pl-5 text-left text-sm font-medium text-gray-700 sm:w-3/4">
            <li>
              With decades of experience, Visa World helps clients navigate the
              Canadian work permit process.
            </li>
            <li>Start your application through our free assessment tool.</li>
          </ul>
        </div>

        {/* Image Section on the Right */}
        <div className="ml-0 mt-8 w-full sm:w-2/4 lg:ml-8 lg:mt-0 lg:w-2/5">
          <img
            src="canadaworking.jpg"
            alt="Immigration Journey"
            className="h-96 w-full rounded-lg object-cover shadow-lg"
          />
        </div>
      </div>

      <Contacts />
    </>
  );
};

export default Canadaworkingvisa;
